import { render, staticRenderFns } from "./swiperSetting.vue?vue&type=template&id=f92cf5c4&scoped=true&"
import script from "./swiperSetting.vue?vue&type=script&lang=js&"
export * from "./swiperSetting.vue?vue&type=script&lang=js&"
import style0 from "./swiperSetting.vue?vue&type=style&index=0&id=f92cf5c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92cf5c4",
  null
  
)

export default component.exports